module.exports = __webpack_public_path__ + "static/img/1.79c8632.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/eng/1.png
// module id = rBx6
// module chunks = 0